import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form } from '../../components';
import * as validators from '../../util/validators';

import css from './EditListingFeaturesForm.module.css';

const EditListingFeaturesFormComponent = (props) => (
    <FinalForm
        {...props}
        mutators={{ ...arrayMutators }}
        render={(formRenderProps) => {
            const {
                disabled,
                ready,
                rootClassName,
                className,
                name,
                handleSubmit,
                pristine,
                saveActionMsg,
                updated,
                updateInProgress,
                fetchErrors,
                filterConfig,
                invalid,
            } = formRenderProps;

            const classes = classNames(rootClassName || css.root, className);
            const submitReady = (updated && pristine) || ready;
            const submitInProgress = updateInProgress;
            const submitDisabled = invalid || disabled || submitInProgress;

            const { updateListingError, showListingsError } = fetchErrors || {};
            const errorMessage = updateListingError ? (
                <p className={css.error}>
                    <FormattedMessage id="EditListingFeaturesForm.updateFailed" />
                </p>
            ) : null;

            const errorMessageShowListing = showListingsError ? (
                <p className={css.error}>
                    <FormattedMessage id="EditListingFeaturesForm.showListingFailed" />
                </p>
            ) : null;

            const options = findOptionsForSelectFilter(
                'amenities',
                filterConfig
            );

            const amenitiesValidator = validators.requiredFieldArrayCheckbox(
                'This field is required'
            );
            return (
                <Form className={classes} onSubmit={handleSubmit}>
                    {errorMessage}
                    {errorMessageShowListing}

                    <FieldCheckboxGroup
                        twoColumns
                        className={css.features}
                        id={name}
                        name={name}
                        options={options}
                        validate={amenitiesValidator}
                    />

                    <Button
                        className={css.submitButton}
                        type="submit"
                        inProgress={submitInProgress}
                        disabled={submitDisabled}
                        ready={submitReady}>
                        {saveActionMsg}
                    </Button>
                </Form>
            );
        }}
    />
);

EditListingFeaturesFormComponent.defaultProps = {
    rootClassName: null,
    className: null,
    fetchErrors: null,
    filterConfig: config.custom.filters,
};

EditListingFeaturesFormComponent.propTypes = {
    rootClassName: string,
    className: string,
    name: string.isRequired,
    onSubmit: func.isRequired,
    saveActionMsg: string.isRequired,
    disabled: bool.isRequired,
    ready: bool.isRequired,
    updated: bool.isRequired,
    updateInProgress: bool.isRequired,
    fetchErrors: shape({
        showListingsError: propTypes.error,
        updateListingError: propTypes.error,
    }),
    filterConfig: propTypes.filterConfig,
};

const EditListingFeaturesForm = EditListingFeaturesFormComponent;

export default EditListingFeaturesForm;
